import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Alokeparna Ray",
  title: "Research Engineer at HEAD acoustics",
  description: `Alokeparna Ray, obtained her bachelors and master’s degree in Communication Engineering. She did her master thesis at the Institute of Technical Acoustics (ITA) on speech intelligibility. During her master studies she also worked as a student assistant at ITA on speech intelligibility, in which she, along with other tasks, conducted hearing experiments with children who suffer from hearing impairment. In 2016 she joined the Research department in HEAD Acoustics and in 2019 moved to the 'Sound Perception & Assessment' group as an acoustics engineer. She now primarily works on psychoacoustics and binaural hearing

  <ul>
    <li><a href="https://www.head-acoustics.com/" target="_blank">https://www.head-acoustics.com/</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/02/authors/alokeparna-ray.jpg",
};

export default author;
